import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import ProLayout from '@ant-design/pro-layout';
import {
  DashboardOutlined,
  TeamOutlined,
  RobotOutlined,
  ShoppingOutlined,
  DatabaseOutlined,
  DollarOutlined,
  UserOutlined,
  SettingOutlined,
  CarOutlined,
  LogoutOutlined,
  CameraOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';
import { Avatar, Dropdown, Space, Typography } from 'antd';
import useAuth from '../hooks/useAuth';

const { Text } = Typography;

const menuRoutes = {
  route: {
    routes: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        icon: <DashboardOutlined />,
      },
      {
        path: '/capture',
        name: 'Captura Productos',
        icon: <CameraOutlined />,
      },
      {
        path: '/dashboard/products',
        name: 'Dashboard Productos',
        icon: <AppstoreOutlined />,
      },
      {
        path: '/distribuidoras',
        name: 'Distribuidoras',
        icon: <TeamOutlined />,
      },
      {
        path: '/bots',
        name: 'Bots IA',
        icon: <RobotOutlined />,
      },
      {
        name: 'Operaciones',
        icon: <ShoppingOutlined />,
        routes: [
          { path: '/operations/products', name: 'Productos', icon: <ShoppingOutlined /> },
          { path: '/operations/inventory', name: 'Inventario', icon: <DatabaseOutlined /> },
          { path: '/operations/sales', name: 'Ventas', icon: <DollarOutlined /> },
          { path: '/operations/hr', name: 'Recursos Humanos', icon: <UserOutlined /> },
          { path: '/operations/transport', name: 'Transporte', icon: <CarOutlined /> },
        ],
      },
      {
        path: '/settings/users',
        name: 'Configuración',
        icon: <SettingOutlined />,
      },
    ],
  },
};

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar sesión',
      onClick: logout,
    },
  ];

  return (
    <ProLayout
      title="GRUPO FAZA"
      logo={false}
      layout="mix"
      navTheme="dark"
      fixSiderbar
      fixedHeader
      location={{ pathname: location.pathname }}
      {...menuRoutes}
      token={{
        header: { colorBgHeader: '#1a1a2e' },
        sider: { colorMenuBackground: '#1a1a2e', colorTextMenu: '#ffffffa6', colorTextMenuSelected: '#fff', colorBgMenuItemSelected: '#E8192C' },
      }}
      menuItemRender={(item, dom) => (
        <div onClick={() => item.path && navigate(item.path)}>{dom}</div>
      )}
      actionsRender={() => [
        <Dropdown key="user" menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer', color: '#fff' }}>
            <Avatar style={{ backgroundColor: '#E8192C' }} icon={<UserOutlined />} />
            <Text style={{ color: '#fff' }}>{user?.name || 'Usuario'}</Text>
          </Space>
        </Dropdown>,
      ]}
      menuFooterRender={(props) => {
        if (props?.collapsed) return null;
        return (
          <div style={{ textAlign: 'center', padding: '16px 0', color: '#ffffff40', fontSize: 12 }}>
            ERPFAZA v1.0
          </div>
        );
      }}
    >
      <Outlet />
    </ProLayout>
  );
};

export default MainLayout;
